import { createContext, useContext } from 'react';
import { FilterContextProps } from './filter.interface';

export const FilterContext: any = createContext<FilterContextProps | null>(
  null,
);
export const useFilterContext: any = () => useContext(FilterContext);
